// @module BTM.GiftCertificatePatch.GiftCertificatePatch
define('BTM.GiftCertificatePatch.GiftCertificatePatch.View'
,	[
	'btm_giftcertificatepatch_giftcertificatepatch.tpl'
	
	,	'BTM.GiftCertificatePatch.GiftCertificatePatch.SS2Model'
	
	,	'Backbone'
    ]
, function (
	btm_giftcertificatepatch_giftcertificatepatch_tpl
	
	,	GiftCertificatePatchSS2Model
	
	,	Backbone
)
{
    'use strict';

	// @class BTM.GiftCertificatePatch.GiftCertificatePatch.View @extends Backbone.View
	return Backbone.View.extend({

		template: btm_giftcertificatepatch_giftcertificatepatch_tpl

	,	initialize: function (options) {

			/*  Uncomment to test backend communication with an example service
				(you'll need to deploy and activate the extension first)
			*/

			// this.model = new GiftCertificatePatchModel();
			// var self = this;
         	// this.model.fetch().done(function(result) {
			// 	self.message = result.message;
			// 	self.render();
      		// });
		}

	,	events: {
		}

	,	bindings: {
		}

	, 	childViews: {

		}

		//@method getContext @return BTM.GiftCertificatePatch.GiftCertificatePatch.View.Context
	,	getContext: function getContext()
		{
			//@class BTM.GiftCertificatePatch.GiftCertificatePatch.View.Context
			this.message = this.message || 'Hello World!!'
			return {
				message: this.message
			};
		}
	});
});
